import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, signup } from "../api/index";
import { ACCESS_TOKEN } from "../constants";

const LOGIN_ERROR = "Error. Please try again later.";

function EmailLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showSignup, setShowSignup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      console.log("Attempting to log in with:", formData);
      const response = await login({
        email: formData.email,
        password: formData.password,
      });
      console.log("Login response:", response);
      
      if (response.status === 200 && response.data.token) {
        localStorage.setItem(ACCESS_TOKEN, response.data.token);
        console.log("Login successful, redirecting to dashboard");
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Invalid response from server");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "An unexpected error occurred");
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    
    // Validate passwords match
    if (formData.password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // Validate password strength
    if (formData.password.length < 3) {
      setError("Password must be at least 8 characters long");
      return;
    }

    try {
      const response = await signup({
        email: formData.email,
        password: formData.password,
      });
      console.log("Signup response:", response);

      if (response.status === 200 && response.data.token) {
      localStorage.setItem(ACCESS_TOKEN, response.data.token);
      console.log("Signup successful, redirecting to dashboard");
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Invalid response from server");
      }
    } catch (err) {
      console.error("Signup error:", err);
      setError(err.message || "An unexpected error occurred");
    }
  };

  return (
    <div className="subscription-section wf-section">
      <div className="div-block-36">
        <h1 className="heading-30">Email Login</h1>
        {error && (
          <div className="w-form-fail">
            <div>{error}</div>
          </div>
        )}
        <form onSubmit={showSignup ? handleSignup : handleSubmit} className="login-form centered-email-form">
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              required
              className="form-input"
            />
          </div>
          {showSignup && (
            <div className="form-group">
              <input
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                required
                className="form-input"
              />
            </div>
          )}
          <button type="submit" className="button Button primary">
            {showSignup ? "Sign Up" : "Log In"}
          </button>
        </form>
        <p className="signup-link">
          {showSignup ? (
            <>
              Already have an account?{' '}
              <a href="#" className="link" onClick={e => { e.preventDefault(); setShowSignup(false); }}>
                Log in here
              </a>
            </>
          ) : (
            <>
              Don't have an account?{' '}
              <a href="#" className="link" onClick={e => { e.preventDefault(); setShowSignup(true); }}>
                Sign up here
              </a>
            </>
          )}
        </p>
      </div>
    </div>
  );
}

export default EmailLogin;
